/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/JiraBusinessTimelineEmbedAppMemoQuery$parameters.ts';
import type { JiraBusinessTimelineEmbedAppMemoQuery } from './__generated__/JiraBusinessTimelineEmbedAppMemoQuery.graphql.ts';

type TimelineEmbedEntrypointComponent = EntryPointComponent<
	{
		timelineEmbedQuery: JiraBusinessTimelineEmbedAppMemoQuery;
	},
	{},
	{},
	{}
>;

export const timelineEmbedEntrypoint: EntryPoint<
	TimelineEmbedEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<TimelineEmbedEntrypointComponent>(
		/* webpackChunkName: "async-business-timeline-embed-entrypoint" */ './JiraBusinessTimelineEmbedAppMemo.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext: { cloudId } }: EntryPointRouteParams) => {
		const projectKey = context.match.params.projectKey;

		if (projectKey == null) {
			throw new Error('Project key missing');
		}

		return {
			queries: {
				timelineEmbedQuery: {
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
					parameters,
					variables: {
						cloudId,
						projectKey,
					},
				},
			},
		};
	},
});
